// Imports
import DD12 from './DD12.svg';
import DD20 from './DJ10.svg';
import DE00 from './DE00.svg';
import DE01 from './DE01.svg';
import DF20 from './DF20.svg';
import DH10 from './DH10.svg';
import DJ10 from './DJ10.svg';
import DJ20 from './DJ20.svg';
import EB00 from './EB00.svg';
import EB10 from './EB10.svg';
import EB30 from './EB30.svg';
import EB40 from './EB40.svg';
import EB80 from './EB80.svg';
import EB90 from './EB90.svg';
import EB91 from './EB91.svg';
import EC10 from './EC10.svg';
import EC11 from './EC11.svg';
import EC30 from './EC30.svg';
import EH00 from './EH00.svg';
import EH10 from './EH00.svg';
import EH20 from './EH20.svg';
import EJ00 from './EJ00.svg';
import EJ20 from './EJ20.svg';
import EL10 from './EL10.svg';
import EM00 from './EM00.svg';
import EM01 from './EM01.svg';
import EM10 from './EM100.svg';
import EM20 from './EM100.svg';
import EM100 from './EM100.svg';
import EM300 from './EM300.svg';
import EM400 from './EM400.svg';
import EV00 from './EV00.svg';
import EV10 from './EV10.svg';
import EV11 from './EV11.svg';
import EV20 from './EV20.svg';
import EV21 from './EV21.svg';
import FA00 from './FA00.svg';
import FA01 from './FA01.svg';
import FB10 from './FB10.svg';
import FB20 from './FB20.svg';
import FB21 from './FB21.svg';
import FB30 from './FB30.svg';
import FB80 from './FB80.svg';
import FB91 from './FB91.svg';
import FC21 from './FC30.svg';
import FC30 from './FC30.svg';
import FD21 from './FC30.svg';
import FF00 from './FF00.svg';
import FG00 from './FG00.svg';
import FG01 from './FG01.svg';
import FG60 from './FG60.svg';
import FIB1 from './FIB1.svg';
import FIB7 from './FIB7.svg';
import FJ00 from './FJ00.svg';
import FJ01 from './FJ01.svg';
import FJ41 from './FJ41.svg';
import FK00 from './FK00.svg';
import FK01 from './FK01.svg';
import FL30 from './FL30.svg';
import FL80 from './FL80.svg';
import FP01 from './FP01.svg';
import FP10 from './FP10.svg';
import FP11 from './FP11.svg';
import FQ01 from './FQ01.svg';
import FQ00 from './FQ00.svg';
import FS00 from './FS00.svg';
import FS01 from './FS01.svg';
import MB00 from './MB00.svg';
import MB70 from './MB70.svg';
import MC00 from './MC00.svg';
import MH21 from './MH21.svg';
import MH22 from './MH22.svg';
import MJ30 from './MJ30.svg';
import MZ00 from './MZ00.svg';

// Exporting
export {
  DD12,
  DD20,
  DE00,
  DE01,
  DF20,
  DH10,
  DJ10,
  DJ20,
  EB00,
  EB10,
  EB30,
  EB40,
  EB80,
  EB90,
  EB91,
  EC10,
  EC11,
  EC30,
  EH00,
  EH10,
  EH20,
  EJ00,
  EJ20,
  EL10,
  EM00,
  EM01,
  EM10,
  EM20,
  EM100,
  EM300,
  EM400,
  EV00,
  EV10,
  EV11,
  EV20,
  EV21,
  FA00,
  FA01,
  FB10,
  FB20,
  FB21,
  FB30,
  FB80,
  FB91,
  FC21,
  FC30,
  FD21,
  FF00,
  FG00,
  FG01,
  FG60,
  FIB1,
  FIB7,
  FJ00,
  FJ01,
  FJ41,
  FK00,
  FK01,
  FL30,
  FL80,
  FP01,
  FP10,
  FP11,
  FQ00,
  FQ01,
  FS00,
  FS01,
  MB00,
  MB70,
  MC00,
  MH21,
  MH22,
  MJ30,
  MZ00
};
